import React from "react";
import { Box } from "@mui/joy";
import { theme } from "../../styles/theme";
import FullPageContainer from "../container/FullPageContainer";
import SimpleMdToTypo from "../../components/common/SimpleMdToTypo";

const TERMS_MD = `
# 디스턴싱 **서비스 이용약관**

## **제1장 총칙**

### **제1조 (목적)**

1. 본 약관은 주식회사 오웰헬스(이하 "회사")가 운영하는 디지털 심리치료 프로그램 디스턴싱(이하 "서비스")를 이용함에 있어 이용자와 회사의 의무, 권리, 책임 및 서비스 이용조건 등 기본적인 사항을 규정하여 이용자와 회사의 권익을 보호함을 목적으로 합니다.

2. 이용자는 본 이용약관을 자세히 읽은 후 이용약관에 동의하지 않을 경우, 본 이용약관에 동의하거나, 서비스에 등록 혹은 이용(이하 "이용")하지 않아야 합니다.

### **제2조 (용어의 정의)**

1. "서비스"라 함은 구현되는 단말기(PC, 휴대형단말기 등의 각종 유무선 장치를 포함)와 상관없이 회사가 제공하는 디스턴싱과 관련된 모든 서비스를 의미합니다.

2. "이용자"라 함은 회사 서비스에 접속하여 본 약관에 따라 회사가 제공하는 서비스를 이용하는 회원과 비회원을 의미합니다.

3. "이용계약"이라 함은 회사가 제공하는 서비스의 이용과 관련하여 이용자가 회사와 계약을 체결하고 회사로부터 서비스 이용에 필요한 아이디를 부여받는 것을 의미합니다.

4. "아이디(ID)"라 함은 회원의 식별, 정보 제공 및 서비스 이용을 위하여 회원이 설정하고 회사가 승인하여 사이트에 등록된 회원 고유 식별자를 의미합니다.

5. "회원"이라 함은 이용계약 시 설정한 아이디(ID)로 사이트에 자유롭게 접속하여 사이트의 정보를 지속적으로 제공받을 수 있거나 사이트가 제공하는 서비스를 계속적으로 이용할 수 있는 자를 말합니다.

6. "비회원"이라 함은 이용계약을 체결하지 않고 서비스를 이용하는 자를 의미합니다. 

7. "코치"라 함은 코치 회원가입 양식 및 자격 기준에 따라 서비스 가입을 완료하여 회사와 이용계약을 체결한 자로 서비스 내에서 디지털 심리치료 프로그램 진행을 보조할 수 있는 자를 의미합니다.

8. "탈퇴"라 함은 회사 또는 회원이 이용계약을 해지하는 것을 의미합니다.

9. "콘텐츠"라고 함은 회사가 제작하거나 이용자가 제작한 부호·문자·음성·음향·화상·동영상 등과 같은 형태의 텍스트, 이미지, 영상 및 각종 파일 모두를 의미합니다.

### **제3조 (약관의 효력 및 변경)**

1. 본 약관은 서비스를 이용하고자 하는 모든 회원에게 그 효력이 발생합니다.

2. 회사는 이 약관의 내용을 서비스의 인터넷 홈페이지(https://distancing.im 이하 "홈페이지"), 디스턴싱 어플리케이션(이하 "앱") 또는 서비스 화면에 게시하거나 기타의 방법으로 이용자에게 공지합니다.

3. 회원이 본 약관에 대하여 "동의하기" 버튼을 클릭하였을 경우 본 약관의 내용을 모두 읽고 이를 충분히 이해하였으며, 회사가 운영하는 본 서비스를 지속적으로 사용하는 것에 동의함을 의미합니다.

4. 이용자가 약관을 상세히 읽지 않아 발생한 피해에 대하여 회사는 책임이 없습니다.

5. 회사는 전자상거래 등에서의 소비자보호에 관한 법률, 약관의 규제에 관한 법률 등 관련법령을 위배하지 않는 범위에서 본 약관을 변경할 수 있습니다.

6. 회사가 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여 현행약관과 함께 제2항의 방식에 따라 그 개정약관의 적용일자 7일 전부터 적용일자 전일까지 공지합니다. 다만, 회원에게 불리한 약관의 개정의 경우에는 그 적용일자 30일 전부터 공지하며 제2항에 명시된 공지 외에도 서비스 내 전자알람, 이메일(E-mail), 로그인 시 동의창 등의 전자적 수단을 통해 별도로 통지하도록 합니다.

7. 회사가 변경약관을 공지하거나 통지하면서, 회원이 약관 변경 적용일까지 거부 의사를 표시하지 아니하면 약관 변경에 동의한 것으로 간주한다는 내용을 공지 또는 통지하였음에도 회원이 변경된 약관의 효력 발생일까지 약관 변경에 대한 거부 의사를 표시하지 않을 때에는 회원이 변경약관에 동의한 것으로 간주합니다. 회원은 변경된 약관에 동의하지 않으면 본 서비스의 이용을 중단하고 이용계약을 해지할 수 있습니다.

8. 본 약관에 동의하는 것은 회사가 운영하는 서비스 및 서비스의 홈페이지에 정기적으로 방문함으로써 약관의 변경사항을 확인하는 것과 제6항의 방식에 따라 회사가 공지하는 약관의 변경사항을 확인하는 것에 동의함을 의미합니다.

### **제4조 (약관 외 준칙)**

1. 본 약관에 밝히지 않은 사항은 전자상거래 등에서의 소비자보호에 관한 법률 등 관계 법령 및 회사가 정한 서비스의 세부이용지침 등의 규정을 따릅니다.

2. 회사는 필요하면 서비스에 적용될 사항 및 세부 이용지침(이하 "개별약관")을 정하여 이를 제3조 제2항의 방법에 따라 공지할 수 있습니다.

3. 본 약관과 관련하여 회사의 정책 변경, 법령의 제·개정 또는 공공기관의 고시나 지침 등에 따라 회사가 홈페이지의 공지사항 게시판 등을 통해 공지하는 내용도 이용계약의 일부를 구성합니다.

### **제5조 (이용계약 체결)**

1. 이용계약은 회원이 되고자 하는 자(이하 "가입신청자")가 약관의 내용에 대하여 동의를 한 다음 회원가입신청을 하고 회사가 이러한 신청에 대하여 승낙함으로써 체결됩니다.

2. 회사는 가입신청자의 신청에 대하여 서비스 이용을 승낙함을 원칙으로 합니다. 다만, 회사는 다음 각 호에 해당하는 신청에 대하여는 승낙을 하지 않거나 사후에 이용계약을 해지할 수 있습니다.

1) 가입신청자가 이 약관에 의하여 이전에 회원자격을 상실한 적이 있는 경우, 단 회사의 회원 재가입 승낙을 얻은 경우에는 예외로 함.

2) 허위의 정보를 기재하거나, 회사가 제시하는 내용을 기재하지 않은 경우

3) 14세 미만 아동의 회원 가입 시 법정대리인(부모 등)의 개인정보 수집·이용 동의를 받지 못하는 경우

4) 이용자의 귀책사유로 인하여 승인이 불가능하거나 기타 규정한 제반 사항을 위반하며 신청하는 경우

3. 제1항에 따른 신청에 있어 회사는 회원의 종류에 따라 전문기관을 통한 실명확인 및 본인인증을 요청할 수 있습니다.

4. 회사는 서비스 관련 설비의 여유가 없거나, 기술상 또는 업무상 문제가 있는 경우에는 승낙을 유보할 수 있습니다.

5. 제2항과 제4항에 따라 회원가입신청의 승낙을 하지 아니하거나 유보한 경우, 회사는 원칙적으로 이를 가입신청자에게 알리도록 합니다.

6. 이용계약의 성립 시기는 회사가 회원 가입이 완료되었음을 홈페이지 또는 앱 상에서 표시한 시점으로 합니다.

7. 회사는 회원에 대해 회사정책에 따라 등급별로 구분하여 이용시간, 이용횟수, 서비스 메뉴 등을 세분하여 이용에 차등을 둘 수 있습니다.

### **제6조 (이용계약 해지)**

회원은 언제든지 회원 탈퇴 또는 계정 해지를 진행하거나 회사에 요청할 수 있으며 회사는 위 요청을 받은 즉시 "개인정보처리방침"에 따라 해당 회원의 정보 삭제를 위한 절차를 밟습니다.

### **제7조 (회사의 권리 및 의무)**

1. 회사는 관련 법령과 본 약관이 금지하거나 공서양속에 반하는 행위를 하지 않으며 본 약관이 정하는 바에 따라 지속적이고 안정적인 서비스를 제공하기 위해서 노력합니다. 다만, 천재지변, 비상사태, 정기점검, 설비장애 또는 이용 폭주 등으로 인하여 서비스 이용에 지장이 있는 경우 등 부득이한 경우에는 그 서비스를 일시 중단하거나 중지할 수 있습니다.

2. 회사는 회원이 안전하게 서비스를 이용할 수 있도록 개인정보 보호를 위해 보안시스템을 구축하며 개인정보처리방침을 공시하고 준수합니다.

3. 회사는 회원이 서비스 이용과 관련하여 의견과 불만을 제공할 경우 이것이 정당하다고 인정한다면 이를 처리하여야 합니다.

4. 회사는 회원이 서비스를 이용함에 있어 법률적인 증명이 가능한 고의 또는 중대한 과실을 입힐 경우 이로 인한 손해를 배상할 책임이 있습니다.

5. 회사는 서비스의 향상과 신규 서비스 개발, 서비스의 효과 분석, 정신건강지표의 집단별 비교분석 및 연구 등을 위하여 회원의 생년월일, 성별, 정신건강 자가검사 점수, 프로그램 진행 내용, 상담 내용 등 서비스 제공 과정에서 작성된 모든 자료와 정보를 개인정보보호법에서 정한 바에 따라 가명처리하여 통계, 연구 또는 논문 작성 등 과학적 연구에 활용할 수 있습니다.

6. 회사는 서비스 질의 향상과 서비스의 홍보를 위하여 서비스에서 작성된 이용 후기 등의 콘텐츠를 기타 포털사이트 등에 제휴와 협약 등을 통해 게시하거나 전송할 수 있습니다.

### **제8조 (회원의 권한 및 의무)**

1. 이용자는 회원가입 또는 회원정보 변경 시 본인에 대하여 정확한 정보를 사실에 근거하여 작성하여야 합니다. 만일 허위 또는 타인의 정보로 작성할 경우에는 향후 서비스 이용과 관련된 일체의 권리를 주장할 수 없습니다.

2. 회원은 본 약관에서 규정하는 사항과 공지사항, 기타 회사가 정한 규정 및 관계법령을 준수하여야 합니다. 이를 지키지 않을 경우, 서비스 이용에 제한을 받거나 적법조치를 포함한 제재를 받을 수 있습니다.

3. 회원은 이름, 이메일, 프로필 등의 회원정보가 변경된 경우 혹은 자신의 아이디 등을 포함한 계정 정보가 유출되어 제3자에 의해 사용되고 있음을 인지한 경우에 회사에 즉시 알려야 합니다. 회사가 관계법령 및 관련 법령에 따라 책임을 지는 경우를 제외하고 회원의 계정 부정 사용으로 인하여 발생하는 모든 결과에 대한 책임은 회원에게 있습니다.

4. 회원은 서비스 내 상품 등을 구매하기 전에 반드시 회사가 제공하는 상품 등의 상세 내용과 조건을 정확하게 확인한 후 구매를 신청하여야 합니다. 구매하려는 상품 등의 상세 내용과 조건을 확인하지 않고 구매하여 발생하는 손해에 대하여 회원이 책임을 부담합니다.

5. 회원은 회사가 서비스를 안전하게 제공할 수 있도록 회사에 협조해야 하며, 회사가 회원의 약관 위반 행위를 발견하여 회원에게 해당 위반 행위에 대하여 소명을 요청할 경우 회원은 회사의 요청에 적극 응하여야 합니다.

6. 만 14세 미만 미성년자인 회원이 서비스를 이용하여 서비스가 제공하는 상품을 구매할 시에는 법정대리인이 해당 계약에 대하여 동의를 하여야 정상적인 상품 등의 구매계약이 체결될 수 있습니다. 만약 미성년자인 회원이 법정대리인의 동의 없이 상품 등을 구매하는 경우 회사 또는 법정대리인은 미성년자의 의사와 무관하게 이를 취소할 수 있습니다.

7. 회원이 회사가 제공하는 유료 서비스를 이용하기 위해서는 상담서비스 이용대금을 결제하여야 하며, 환불에 대하여 회사가 공지하는 "취소 및 환불규정"을 따라야 합니다.

8. 회원은 서비스 이용에 필요한 최소한의 구체적이고 진실한 정보를 제공하여야 하며, 정보가 부족할 경우, 서비스 이용에 제한을 받을 수 있습니다.

9. 회원은 채팅·음성·영상 등을 통해 코치와 접촉할 시 코치의 인권을 존중하여야 합니다. 만일 코치를 접촉할 시에 욕설·비방·성희롱·음란행위 등 기타 타인에게 위해가 되는 행위들을 할 경우에는 서비스 이용이 즉각 중단될 수 있으며 향후 서비스 이용에 제한이 있을 수 있습니다. 또한 회사는 그러한 일이 발생하였을 때 진상을 규명하고 피해자의 요구에 따라 해당 회원을 경찰 등 유사기관에 신고할 수 있습니다.

10. 회원은 코치의 귀책사유 있는 불법 내지 위법행위를 알게 된 경우 회사에 해당 사실을 통지하며, 회사는 관련 사실관계를 확인하고 코치와의 계약 해지 등 필요한 조치를 취합니다.

11. 본조 제11항의 경우, 회원은 코치에 대한 책임 청구 이외에 회사에 대하여는 코치의 귀책사유 있는 불법 내지 위법행위에 대한 책임을 물을 수 없습니다.

### **제9조 (회원의 개인정보 보호)**

1. 회사는 관계법령이 정하는 바에 따라 회원의 개인정보를 보호하기 위해 노력합니다.

2. 회원이 회사에 제공하는 정보 일체는 회사의 개인정보처리방침에 따릅니다. 단, 회사의 공식사이트와 어플리케이션 이외의 회사에 링크되어 있는 웹사이트들에서는 회사의 개인정보처리방침이 적용되지 않습니다.

3. 회사는 이용자의 귀책사유로 인해 노출된 정보에 대해서 일체의 책임을 지지 않습니다.

### **제 10조 (회원의 금지행위)**

1. 회원은 다음 각 호에 해당하는 행위를 해서는 안 되며, 해당행위를 하는 경우 서비스의 일부 또는 전부를 이용 정지하거나 서비스 이용 계약을 임의로 해지할 수 있으며, 이 경우 발생하는 손해에 대한 책임은 회원이 부담합니다. 회사는 필요한 경우 회원의 금지행위 사실을 관련 정부기관 또는 사법기관에 통지할 수 있으며 회원은 적법조치를 포함한 제재를 받을 수 있습니다.

1) 서비스 이용 신청 또는 변경 시 허위 사실을 기재하거나, 타인의 정보를 도용하여 부정하게 사용하는 행위

2) 회사가 게시한 정보를 변경하는 행위

3) 회사가 정한 정보 이외의 정보를 송신하거나 게시하는 행위

4) 회사와 또는 제3자의 저작권 등 기타 권리를 침해하는 행위

5) 회사 또는 제3자의 명예를 손상시키거나 업무를 방해하는 행위

6) 불특정 다수를 대상으로 하여 광고 또는 선전을 게시하거나 음란물 또는 불쾌감을 조성할 수 있는 글을 게시하는 행위

7) 회사의 서비스를 이용하여 얻은 정보를 사전 승낙 없이 복제 또는 유통시키거나 상업적으로 이용하는 행위

8) 욕이나 음담패설, 외설적 또는 규정에 적합하지 않은 행위

9) 컴퓨터 소프트웨어, 하드웨어, 전기통신 장비 정상적인 가동을 방해 또는 파괴할 적으로 고안된 소프트웨어 바이러스, 기타 다른 컴퓨터 코드, 파일, 프로그램을 포함하고 있는 자료를 게시하거나 전송하는 행위

10) 회사의 동의 없이 영리를 목적으로 서비스를 사용하는 행위

11) 기타 본이용약관 또는 관계 법령에 위배 또는 미풍양속에 반하는 행위

2. 회원이 서비스 이용 과정에서 욕이나 음담패설, 외설적 행위를 할 경우 피해 주체가 된 코치는 증빙 자료 확보 및 법적조치를 위해 회원의 금지행위에 대해 서비스 내 화면 촬영 등을 통하여 적절한 조치가 취해질 때까지 보유할 수 있으며, 이 과정에서 회원의 정신, 재산, 사회적 정보와 개인정보(성별, 나이 등)가 수집될 수 있습니다.

3. 회원은 귀책사유로 인하여 회사나 다른 회원 또는 코치가 입은 손해를 배상할 책임이 있습니다.

### **제11조 (서비스 이용 제한)**

1. 다음의 사항에 해당하는 경우 회원의 서비스에 대한 접근이 차단되거나 서비스 이용이 제한될 수 있습니다.

1) 다른 회원 또는 제3자를 비방하거나 중상 모략으로 명예를 손상시키는 경우

2) 음란물, 욕설 등 공서양속에 위반되는 내용의 정보, 문장, 도형 등을 유포하는 경우

3) 범죄행위와 관련이 있다고 판단되는 내용의 콘텐츠를 게시하는 경우

4) 다른 회원 또는 제3자의 저작권 등 기타 권리를 침해하는 내용

5) 종교적, 정치적 분쟁을 야기하는 내용으로서, 이러한 분쟁으로 인하여 회사의 업무가 방해되거나 방해되리라고 판단되는 경우

6) 타인의 개인정보, 사생활을 침해하거나 명예를 손상시키는 경우

7) 동일한 내용을 중복하여 다수 게시하는 등 게시의 목적에 어긋나는 경우

8) 불필요하거나 승인되지 않은 광고, 판촉물을 게재하는 경우

9) 그 외 불법적이거나 부당한 행위를 한 경우

2. 회원이 작성한 콘텐츠로 인한 법률상 이익 침해를 근거로, 다른 회원 또는 제3자가 회원 또는 회사를 대상으로 하여 민형사상의 법적 조치(예: 고소, 가처분신청, 손해배상청구소송)를 취하는 동시에 법적 조치와 관련된 게시물의 삭제를 요청해오는 경우, 회사는 동 법적 조치의 결과(예: 검찰의 기소, 법원의 가처분결정, 손해배상판결)가 있을 때까지 관련 게시물에 대한 접근을 임시적으로 제한할 수 있습니다.

## **제2장 서비스 이용**

### **제12조 (서비스의 내용)**

회사가 제공하는 서비스는 아래와 같습니다

1) 정신건강 관리를 위한 인지 요법 (서비스 내 문답과 기록을 바탕으로 한 인지적 교정)

2) 정신건강 관리를 위한 행동 요법 (행동계획, 행동실험 등을 바탕으로 한 행동적 교정)

3) 기타 정신건강 관리를 위한 시∙청각 교육 자료

4) 서비스 진행을 보조하기 위한 코치의 채팅

5) 기타 회사가 본 서비스와 부합하며 회원의 편의성을 향상시킨다고 판단하여 제공하는 모든 종류의 서비스

### **제13조 (서비스 이용계약)**

1. 서비스 이용계약은 이용자가 회사가 정한 이용약관에 대하여 동의를 하고 회원가입에 필요한 온라인 신청 양식을 작성하여 서비스 이용을 신청한 후 이에 대하여 회사가 승인함으로써 성립합니다.

2. 회원이 서비스 이용계약을 체결하여 서비스를 이용하고자 할 경우 서비스 이용 전 준수사항 등을 확인하고 회사에서 요청하는 내용에 대해 응답 및 동의를 해야 합니다.

3. 서비스 이용계약에 따른 대금 결제 이후 이용신청의 정정, 취소 및 환불을 원할 경우 회원은 회사의 취소 및 환불 규정 및 절차에 따라 이를 진행하여야 합니다.

### **제14조 (서비스 이용자격)**

1. 만 14세 미만의 미성년자인 회원이 서비스를 이용하여 상품 등을 구매하고자 할 경우, 법정대리인으로부터 서비스 이용에 대한 동의를 받아야 합니다. 이 경우 법정대리인은 이용약관에서 규정하는 회원의 권리 및 의무를 모두 가집니다.

2. 본 서비스를 이용하려면 앱(Application) 또는 웹(PC)가 반드시 필요하며, 정기적인 업데이트가 필요할 수 있습니다. 또한 이러한 요인에 의해 기능이 일부 영향을 받을 수 있으며, 이용자는 해당 내용에 대해 이해하고 있어야 합니다.

3. 서비스 내에서 심리치료 활동지, 코치의 채팅 등 회사가 지정한 특정 서비스의 경우 회원가입을 하지 않은 이용자에게는 이용이 제한될 수 있습니다.

### **제15조 (서비스 이용 시 주의 사항)**

1. 회사가 제공하는 콘텐츠는 의사와 상담사를 비롯한 전문가의 검수를 받은 신뢰할 수 있는 정보이지만 개개인의 증상 내지 상태에 대한 의학적 진단이나 처방이 아닙니다. 의료 및 질병과 관련한 일체의 의문점이 있을 경우에는 반드시 의사와 직접 상담하여야 합니다.

2. 앱을 통해 제공되는 심리치료 프로그램은 정신건강을 관리하는 데에 도움이 될 수 있지만 의학적 진단이나 처방과는 명확히 구별되므로 앱 서비스로 의사의 진료를 대신할 수는 없습니다. 이와 관련하여 회원의 부주의나 실수로 야기되는 문제점에 대해서 회사는 일체의 책임을 지지 아니합니다.

3. 본 서비스는 공신력이 있는 정신건강 지표들을 다수의 협회 및 저자로부터 승인을 얻어 자가검사 도구로 사용하고 있기는 하지만 자가검사는 공인된 정보의 객관적 전달 수단일 뿐 의학적 진단 내지 처방을 의미하는 것이 아닙니다. 자가검사 결과와는 별개로 의료 및 질병과 관련한 일체의 의문점이 있을 경우에는 반드시 의사와 직접 상담을 하여야 하며, 질병의 진단은 반드시 의사의 진료를 통해 이루어져야 합니다. 이와 관련하여 회원의 부주의나 실수로 야기되는 문제점에 대해서 회사는 일체의 책임을 지지 아니합니다.

### **제16조 (서비스 이용요금)**

1. 회사가 제공하는 유료서비스는 해당 서비스에 명시된 요금을 지불하여야 사용 가능합니다.

2. 회사는 유료서비스 이용요금을 회사와 계약한 전자지불업체에서 정한 방법에 의하거나 회사가 정한 청구서에 합산하여 청구할 수 있습니다.

3. 유료서비스 이용을 통하여 결제된 대금에 대한 취소 및 환불은 회사의 취소 및 환불 규정에 따릅니다.

4. 회원의 개인정보도용 및 결제사기로 인한 환불요청 또는 결제자의 개인정보 요구는 법률이 정한 경우 외에는 거절될 수 있습니다.

5. 무선 서비스 이용 시 발생하는 데이터 통신료는 별도이며 가입한 각 이동통신사의 정책에 따릅니다.

6. 유료 전화 상담 시 인터넷 환경의 문제로 시스템 전화 연결이 불안정할 경우 050 가상번호를 이용하여 상담이 진행될 수 있습니다. 이때 통화는 발신자 부담으로 진행되며, 발생 비용은 각 이동통신사의 정책에 따릅니다.

### **제17조 (대금결제)**

1. 회원은 서비스 내 유료서비스를 이용하기 위해서 신용카드 정보 등 결제 정보를 입력하여야 합니다.

2. 회원이 서비스 내에서 유료서비스에 대한 "구매(하기)", "결제(하기)", "(결제)확인" 등의 버튼을 클릭함으로써 본 이용약관 및 게시된 구매조건에 따라 서비스 이용계약 체결을 위한 청약을 하고, 회사가 서버 제어를 통해 청약에 승낙하는 경우에 서비스 이용계약이 성립하고, 구매대금이 결제됩니다.

3. 유료서비스의 구매대금을 외화로 결제하는 경우에는 환율‧수수료 등으로 인하여 실제 청구금액이 서비스에서 표시된 가격과 달라질 수 있습니다.

4. 회원이 등록한 결제대금으로 이용대금의 결제가 실패하는 경우 서비스 이용계약은 자동으로 취소됩니다.

5. 회원은 대금결제 후 제공되는 컨텐츠를 이용하기 전까지 회사가 정한 절차에 따라 서비스 이용계약을 해지 수 있으며, 이 경우 서비스 내 고지한 사항에 따라 환불액이 결정됩니다. 컨텐츠 이용 이후 이용계약의 해지는 불가합니다.

### **제18조 (청약 철회 등)**

1. 회사와 서비스의 구매에 관한 계약을 체결한 회원은 구매계약일과 유료서비스 이용 가능일 중 늦은 날부터 7 일 이내에 청약철회를 할 수 있습니다.

2. 「전자상거래 등에서의 소비자보호에 관한 법률」등 관련 법령에서 규정하는 청약철회가 불가능한 서비스의 경우 청약철회권이 제한됩니다

3. 회원은 제1항 및 제2항에도 불구하고 구매한 유료서비스의 내용이 표시, 광고의 내용과 다르거나 구매계약의 내용과 다르게 이행된 경우에 해당 서비스가 이용 가능하게 된 날부터 3 개월 이내, 그 사실을 안 날 또는 알 수 있었던 날부터 30 일 이내에 청약철회를 할 수 있습니다.

4. 회원이 청약철회를 할 경우 회사는 결제수단의 제공자를 통해 구매내역을 확인합니다. 또한 회사는 회원의 정당한 철회 사유를 확인하기 위해 회원에게서 제공받은 정보를 통해 회원에게 연락하여 추가적인 증빙을 요구할 수 있으며, 이에 대한 확인이 완료될 때까지 거래진행을 중지하거나 확인이 불가한 해당거래를 취소할 수 있습니다.

### **제19조 (과오납금의 환급)**

1. 회사는 과오납금이 발생하는 경우 과오납금을 회원에게 환급합니다. 다만, 과오납금이 회사의 고의 또는 과실 없이 회원의 과실로 인하여 발생한 경우에는 그 환급에 소요되는 실제 비용은 합리적인 범위 내에서 회원이 부담합니다.

2. 회사는 회원이 선택한 결제수단에 따라 결제를 취소 또는 해당 결제수단을 통한 환급을 할 수 있습니다.

3. 회사는 과오납금의 환급을 처리하기 위해 회원에게서 제공받은 정보를 통해 회원에게 연락할 수 있으며, 필요한 정보의 제공을 요청할 수 있습니다.

### **제20 조 (서비스 내용 변경/종료 통지 등)**

1. 회사가 서비스 내용을 변경하는 경우 회사는 회원의 등록된 전자우편 주소로 이메일을 통하여 서비스 내용의 변경 사항을 통지하거나, 웹사이트 내에 공지합니다.

2. 회사는 영업양도․분할․합병 등에 따른 영업의 폐지, 서비스의 현저한 수익 악화 등 경영상의 사유로 인해 서비스를 지속하기 어려운 경우에는 서비스 전부를 중단할 수 있습니다. 이 경우 중단일자 30일 이전까지 중단일자, 중단사유 등을 홈페이지 및 앱 초기화면 또는 그 연결화면을 통해 공지하고 회원의 등록된 전자우편 주소로 이메일을 통하여 서비스 내용의 변경 사항 또는 종료를 통지합니다.

### **제21조 (서비스 이용 제한 및 중지)**

1. 회사는 다음의 각 호에 해당하는 사유가 발생할 경우, 회원의 서비스 이용을 제한하거나 중지시킬 수 있습니다.

1) 회원이 회사 서비스의 운영을 고의 또는 중과실로 방해하는 경우

2) 다른 사람의 명의사용 등 이용자가 허위 정보로 서비스를 신청하는 경우

3) 신청 시 필요한 사항을 허위로 기재하거나 중요한 사항에 기재누락 오기가 있는 경우

4) 부정한 방법으로 서비스를 이용하거나 정보를 조작하여, 회사에 피해를 줄 수 있다고 판단하는 경우

5) 회사에서 공지한 주의사항 또는 경고사항을 준수하지 않거나 동의하지 않는 경우 6) 서비스용 설비 점검, 보수 등의 이유로 서비스 제공이 불가능한 경우

7) 전기통신사업법에 규정된 기간통신사업자가 전기통신서비스의 제공을 중지했을 경우

8) 국가비상사태, 서비스 설비의 장애 또는 서비스 이용의 폭주 등으로 서비스 이용에 지장이 있는 때

9) 음란물, 욕설 등 공공질서와 미풍양속에 위반되는 행위를 하는 경우

10) 회원의 서비스 이용이 범죄행위와 관련이 있다고 판단되는 경우

11) 자살을 목적으로 하거나 이를 미화, 방조, 또는 권유하여 자살 충동을 일으킬 우려가 있는 행위를 하는 경우

12) 회사, 타인의 저작권 등 지적재산권을 침해하는 경우

13) 타인의 개인정보, 사생활을 침해하거나 비방, 허위사실 등으로 명예를 손상시키는 행위를 하는 경우

14) 불필요하거나 승인되지 않은 광고, 판촉물 등을 유포하는 경우

15) 커뮤니티 내 동일한 내용을 중복하여 다수 게시하거나 관리자를 사칭하는 등 커뮤니티 서비스의 본 목적에 어긋나는 행위를 하는 경우

16) 기타 중대한 사유로 인하여 회사가 서비스 제공을 지속하는 것이 부적당하다고 인정하는 경우

2. 회사는 전항의 규정에 의하여 서비스의 이용을 제한하거나 중지한 때에는 그 사유 및 제한기간 등을 회원에게 알려야 합니다.

3. 회사는 회원의 서비스 신청 이후에 제1항의 사유가 있음을 알게 된 경우, 이용계약의 해지 또는 중단 등의 이용제한 조치를 취할 수 있습니다.

### **제22조 (회원정보와 이용정보)**

1. 회원은 언제든지 자신의 개인정보를 열람하고 수정할 수 있습니다.

2. 회원이 전항의 변경사항을 수정하지 않아 불이익이 발생하였을 경우, 이에 대해 회사는 책임지지 않습니다.

3. 회원은 정신건강 관리 서비스를 이용하기 위하여 코치의 질문에 대한 답변, 생각기록 등 다양한 형태의 기록을 작성하여야 합니다. 서비스 특성상 서비스 진행 과정에서 기록을 통해 수집되는 내용에는 민감 정보가 포함될 수 있지만 기록의 내용은 다른 사람이나 기관에게는 전달되지 않습니다. 단, 회사는 본 약관 제 7 조 제 5 항에 명시된 범위 내에서 상담 정보를 연구 및 통계 처리에 활용할 수 있습니다.

4. 서비스 제공 및 이용을 위하여 수집된 회원의 개인정보는 개인정보처리방침에 따라 처리되며 회사는 해당 기록을 서버에 저장할 수 있습니다.

5. 회원의 개인정보, 걱정 일기 기록 등 그리고 회사가 운영하는 서비스에 회원이 게시한 글 등 서비스와 관련된 모든 정보와 자료는 회사가 보관합니다.

6. 서비스와 관련된 모든 정보와 자료는 더 나은 서비스를 위하여 개인정보보호법에서 정한 가명처리 후 회사의 서비스 개발과 연구, 통계, 빅데이터 활용 등에 활용될 수 있습니다.

### **제23조 (이용계약의 해지)**

1. 회원이 이용계약의 해지를 원할 경우, 서비스 내의 회원 탈퇴 기능을 통하여 언제든지 회원탈퇴를 신청할 수 있습니다. 단, 해지의사를 통지하기 전에 현재 진행 중인 모든 상품의 거래를 완료하거나 규정에 맞게 취소 또는 환불을 진행하여야 하며, 거래를 취소했을 때 발생할 수 있는 불이익은 회원 본인이 부담하여야 합니다.

2. 회원 탈퇴로 인해 발생한 불이익에 대한 책임은 회원 본인이 부담하여야 하며, 이용계약이 종료되면 회사는 관련 법령에 저촉되지 않는 한 회원에게 부가적으로 제공한 각종 혜택을 회수할 수 있습니다.

3. 회사는 회원이 본 이용약관 또는 관계법령 등을 위반하는 경우, 이용계약을 해지할 수 있습니다. 회사가 본항에 따라 이용계약을 해지한 경우 재가입이 제한됩니다.

4. 본 항에 따라 해지를 한 회원은 이 약관이 정하는 회원등록절차와 관련조항에 따라 회원으로 다시 가입할 수 있습니다. 다만 판촉이벤트 참여 등 이용자에게 제한적으로 제공되는 서비스 및 혜택 등에 대해서는 중복 적용이 불가능할 수 있으며, 해당 서비스 및 혜택을 부정하게 이용할 목적으로 회원탈퇴 후 재가입을 신청하는 경우 회사는 해당 이용자의 재가입을 일정기간 동안 제한할 수 있습니다.

## **제3장 기타**

### **제24조 (지식재산권)**

1. 회사는 지식재산권을 존중하며, 본 서비스 이용자들이 타인의 지식재산권을 존중할 것이라 기대합니다.

2. 회사가 직접 작성한 콘텐츠, 회사가 개발한 검사지와 해설지, 기타 회사가 제작한 모든 저작물에 대한 저작권과 지식재산권은 모두 회사에 귀속됩니다. 회원은 회사가 제공하는 서비스를 이용함으로써 얻은 정보를 회사의 사전 허락 없이 복제, 재가공, 전송, 출판, 배포, 방송, 기타 방법에 의하여 영리 목적으로 이용하거나 제3자에게 이용하게 하여서는 안 됩니다.

3. 회원이 서비스 내에 게시한 게시물의 저작권은 해당 게시물의 저작자에게 귀속됩니다. 단, 회사는 게시물에 대하여 회사가 다음과 같은 방법과 조건으로 이용하는 것을 허락합니다.

1) 해당 게시물을 이용, 편집 형식의 변경 및 기타 변형하는 것(공표, 복제, 공연, 전송, 배포, 방송, 2차적 저작물 작성 등 어떠한 형태로든 이용 가능하며, 이용기간과 지역에는 제한이 없음)

2) 이용자 콘텐츠를 제작한 이용자의 사전 동의 없이 거래를 목적으로 이용자 콘텐츠를 판매, 대여, 양도 행위를 하지 않음

4. 회사 이외 이용자, 의사, 상담사가 타인이 작성한 게시물의 전부 또는 일부를 복제, 배포, 전송하는 등의 방법으로 타인의 저작권을 침해하는 행위는 금지됩니다.

5. 회원이 서비스를 이용하는 과정 중 서비스 내에 게시하는 글 및 기록 등에 대하여 회사는 모든 자료와 정보를 익명 또는 가명화하여 디지털 치료와 관련한 연구, 통계, 개발에 활용할 수 있으며 익명 또는 가명화된 데이터를 빅데이터 활용 또는 연구를 위해 제3자에게 이용을 허락할 수 있습니다.

### **제25조 (서비스 게시물의 등록 및 관리)**

1. 회원은 약관에서 규정하는 범위 내에서 자율적으로 게시물을 작성할 수 있습니다.

2. 회사는 회원의 게시물이 정보통신망 이용촉진 및 정보보호 등에 관한 법률 및 저작권법 등 관련법에 위반되는 내용을 포함하였을 경우, 권리자는 관련법이 정한 절차에 따라 해당 게시물의 게시중단 및 삭제 등을 요청할 수 있으며, 회사는 관련법에 따라 조치를 취하여야 합니다. 또한, 권리자의 요청이 없는 경우라도 권리침해가 인정될 만한 사유가 있거나 기타 회사 정책 및 관련법에 위반되는 경우에는 관련법에 따라 해당 게시물에 대해 임시조치 등을 취할 수 있습니다.

### **제26조 (광고)**

1. 회사는 본 서비스에 당사 또는 제3자의 광고를 진행할 수 있습니다. 또한 수신에 동의한 회원에 한하여 전자우편, 문자서비스(LMS/SMS), 푸시메시지(Push Notification) 등의 방법으로 광고성 정보를 전송할 수 있습니다. 이 경우 회원은 언제든지 수신을 거절할 수 있으며, 회사는 회원의 수신 거절 시 광고성 정보를 발송하지 아니합니다.

2. 회사가 제공하는 서비스 중의 배너 또는 링크 등을 통해 타인이 제공하는 광고나 서비스에 연결될 수 있습니다.

3. 제2항에 따라 타인이 제공하는 광고나 서비스에 연결될 경우 해당 영역에서 제공하는 서비스는 회사의 서비스 영역이 아니므로 회사가 신뢰성, 안정성 등을 보장하지 않으며, 그로 인한 회원의 손해에 대하여도 회사는 책임을 지지 않습니다.

### **제27조 (손해배상)**

1. 회사 또는 회원은 본 약관을 위반하여 상대방에게 손해를 입힌 경우에는 그 손해를 배상할 책임이 있습니다. 다만, 고의 또는 과실이 없는 경우에는 그러하지 아니 합니다

2. 회사가 개별서비스 제공자와 제휴 계약을 맺고 회원에게 개별서비스를 제공하는 경우에 회원이 이 개별서비스 이용약관에 동의를 한 뒤 개별서비스 제공자의 고의 또는 과실로 인해 회원에게 손해가 발생한 경우에 그 손해에 대해서는 개별서비스 제공자가 책임을 집니다.

### **제28조 (면책조항)**

1. 회사는 아래의 각 호에 해당하는 경우 책임이 면제되며 이로 인한 손해를 배상할 책임도 없습니다.

1) 천재지변, 전쟁 및 기타 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없을 경우

2) 기간통신사업자가 전기통신서비스를 중지하거나 정상적으로 제공하지 아니하여 손해가 발생한 경우

3) 서비스용 설비의 보수, 교체, 정기점검, 공사 등의 부득이한 사유로 손해가 발생할 경우(다만, 회사의 고의 또는 과실에 의한 경우에는 제외함)

4) 서비스 제공을 위하여 회사와 서비스 제휴계약을 체결한 제3자의 고의적인 서비스 방해가 있는 경우

5) 회원의 귀책사유로 인해 서비스 이용의 장애 또는 손해가 발생할 경우

6) 이용자의 컴퓨터 오류에 의해 손해가 발생할 경우, 또는 회원이 신상정보 및 이메일 주소를 부정확하게 입력하여 손해가 발생할 경우

7) 회원이 서비스를 이용하여 기대하는 수익을 얻지 못하거나 상실한 경우

8) 회원이 서비스를 이용하면서 얻은 자료로 손해가 발생할 경우(다만, 회사의 고의 또는 중대한 과실에 의한 경우는 제외함)

9) 회원이 서비스를 이용하며 타 회원으로 인해 정신적 피해를 입게 될 경우

10) 회원이 서비스를 이용하면서 자료를 게시, 전송, 저장, 조회함으로써 법적인 책임이 발생한 경우

11) 회원 상호간 및 회원과 제3자 상호 간에 서비스를 매개로 분쟁이 발생한 경우

12) 회원이 자가검사와 정신건강 관련 정보 등 회사에서 제공하는 자가검사 도구와 콘텐츠가 본인과 맞지 않다고 판단하는 경우

2. 회사는 회원에게 무료로 제공하는 서비스의 이용과 관련해서는 어떠한 손해도 책임을 지지 않습니다. 그러나 회사의 고의 또는 중과실에 의한 경우에는 그러하지 아니합니다.

3. 회사는 회원이 서비스와 관련하여 게재한 정보, 자료, 사실의 신뢰도와 정확성 등의 내용에 대하여 해당 정보가 허위임을 인지하지 못했을 경우에 대해 책임을 지지 않습니다.

### **제29조 (규정의 준용)**

1. 본 약관은 대한민국법령에 의하여 규정되고 이행됩니다.

2. 본 약관에 규정되지 않은 사항에 대해서는 관련법령 및 상관습에 의합니다.

### **제30조 (분쟁의 조정 및 기타)**

1. 회사와 회원은 서비스와 관련하여 발생한 분쟁을 원만하게 해결하기 위하여 서로 성실하게 노력하여야 합니다.

2. 회사가 제공하는 서비스는 합법적인 목적으로만 사용되어야 하며, 대한민국법령에 반하는 형태의 사용은 금지됩니다. 회원의 금지된 형태의 사용으로 인하여 손해가 발생할 경우 회사는 이에 대해 책임을 지지 않습니다.

3. 서비스 이용으로 발생한 분쟁에 대해 소송이 제기되는 경우 법령에 정한 절차에 따른 법원을 관할 법원으로 합니다.
`;

export default function TermsOfService() {
  return (
    <FullPageContainer
      hasFooter={false}
      backgroundColor={theme.vars.palette.Background.Level1}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: 800,
          height: "100%",
          overflowY: "auto",
          px: 3,
          py: 2,
          color: (t) => t.vars.palette.Content.Medium,
        }}
      >
        <SimpleMdToTypo source={TERMS_MD} />
      </Box>
    </FullPageContainer>
  );
}
